import React, { Suspense } from "react";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import { Box, CircularProgress, CssBaseline, useTheme } from "@mui/material";
import { Footer, Header, Sidebar } from "../components";
import { LoaderContainer } from "react-global-loader";

import routes from "./routes";

const Loader = () => {
  return (
    <Box
      height="100vh"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
    >
      <CircularProgress color="secondary" />
    </Box>
  );
};



export function Notfound() {
  return <div>404 - Page Not Found</div>;
}

const router = createBrowserRouter(routes);

function NewRouter() {
  return (
    <>
      {" "}
      <LoaderContainer>
        <CircularProgress color="secondary" />
      </LoaderContainer>
      <Suspense fallback={<Loader />}>
        <RouterProvider router={router} />
      </Suspense>
    </>
  );
}

export default NewRouter;
